import { EInstallTestState } from "~domain/install-tests/models/install-test-state-model.ts";

const testInstallStatus: Record<EInstallTestState, string> = {
  [EInstallTestState.OK]: "Ok",
  [EInstallTestState.NOK]: "Nok",
  [EInstallTestState.UNKNOWN]: "Inconnu",
};

export const VX_TESTS_TABLE_FRENCH_LOCALE = {
  searchPlaceholder: "Rechercher une valeur...",
  noTestFound: "Aucun test trouvé...",
  headers: {
    testId: "Test Id",
    state: "Résultat",
    resultDetails: "Détails",
    measuredPower: "Puissance mesurée",
    serialNumber: "Numéro de série",
    deviceType: "Type d'appareil",
    pilotHwId: "Pilote Hw Id",
    isAutoTestAllowed: "Autotest autorisé ?",
    startDate: "Date de début",
    endDate: "Date de fin",
    receptionDate: "Date de réception",
  },
  filters: {
    placeholders: {
      testId: "Rechercher par test id...",
      state: "Rechercher par résultat...",
      serialNumber: "Rechercher par numéro de série...",
      deviceType: "Rechercher par type d'appareil...",
      pilotHwId: "Rechercher par pilote hw id...",
      startDate: "Rechercher par date de début...",
      endDate: "Rechercher par date de fin...",
      receptionDate: "Rechercher par date de réception...",
    },
  },
  testInstallStatus: testInstallStatus,
};
